import { css } from 'lit';
export const chainSelectorListStyle = css `
  :host {
    display: flex;
    width: 100%;
    min-width: 320px;
  }

  .title {
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0;
    color: var(--color-content-content-primary);
  }
`;
//# sourceMappingURL=chain-selector-list.style.js.map